<template>
    <div>
        <v-snackbar :color="snackbarColor" v-model="snackbarValue" top>
            {{ snackbarText }}
        </v-snackbar>
        <v-fade-transition>
            <v-overlay absolute :value="active_poll && has_not_voted && visible && display" :dark="dark"
                       z-index="3">
                <v-card color="transparent" height="100%" width="100%" elevation="0" style="opacity: .85"
                        v-if="active_poll && has_not_voted">
                    <v-container class="fill-height">
                        <v-row align="self-start">
                            <v-col>
                                <v-card color="primary" :dark="dark" rounded>
                                    <v-card-title class="text-break">
                                      <v-row no-gutters align="center">
                                        <v-col>
                                          <span>{{active_poll.question}}</span>
                                        </v-col>
                                        <v-col cols="auto">
                                          <v-btn icon :dark="dark" @click.stop.prevent="hide">
                                            <v-icon>mdi-close</v-icon>
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-card-title>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row align="self-end">
                            <v-col cols="6" v-for="(answer, idx) in active_poll.answers"
                                   :key="idx">
                                <v-card color="primary"
                                        @click.stop.prevent="vote(answer.id)"
                                        >
                                  <v-card-subtitle :class="dark ? 'white--text text-subtitle-1' : 'text-subtitle-1'">{{ answer.answer }}</v-card-subtitle>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-overlay>
        </v-fade-transition>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import gql from 'graphql-tag';
    import snackbar from '@/mixins/snackbar';


    export default {
        name: 'PollOverlay',
        props: {
            player: Object,
        },
        mixins: [snackbar],
        data: () => ( {
            voted: [],
          display: true
        } ),
        mounted ()
        {
            if ( this.active_poll && this.visible )
            {
              this.display = true
                this.player.setControls( false );
            }
        },
        watch: {
            active_poll ( active_poll )
            {
                if ( active_poll && this.has_not_voted && this.visible )
                {
                  this.display = true
                    this.player.setControls( false );
                }
                else
                {
                  this.display = false
                    this.player.setControls( true );
                }
            },
        },
        computed: {
            ...mapState( ['event', 'room'] ),
            ...mapGetters( ['dark'] ),
            visible ()
            {
                return this.$vuetify.breakpoint.mdAndUp;
            },
            active_poll ()
            {
                let room = this.room;
                if ( room && room.pollSetting && room.pollSetting.active_poll )
                {
                    return room.pollSetting.active_poll;
                }
                return null;
            },
            has_not_voted ()
            {
                return this._.findIndex( this.voted, ( poll_id ) =>
                {
                    return `${ poll_id }` === `${ this.active_poll.id }`;
                } ) === -1;
            },
        },
        methods: {
          hide() {
            this.display = false
            this.$nextTick(()=>{this.player.setControls( true )});
          },
            vote ( id )
            {
                // Result
                this.voted.push( this.active_poll.id );
                this.$nextTick(()=>{this.player.setControls( true )});
                this.$apollo.mutate( {
                    // Query
                    mutation: gql`mutation ($id: ID!) {
                                submitAnswer(id: $id)
                              }`,
                    variables: {
                        id: id,
                    },
                } ).then( () =>
                {
                    this.showSuccessSnackbar( this.$t('room.poll.messages.success') );
                } ).catch(()=>{
                    this.showGeneralErrorSnackbar();
                });
            },
        },
    };
</script>

<style scoped>

</style>